var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-header",
            [_c("b-card-title", [_vm._v("Budget Variance Report")])],
            1
          ),
          _c("apexchart", {
            attrs: {
              type: "line",
              height: _vm.chartOptions.chart.height,
              options: _vm.chartOptions,
              series: _vm.series,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }